import { createReducer } from 'redux-create-reducer';
import {
  updateDurationAction,
  updateDurationUnitAction,
  updateInterventionDateAction,
  updateInterventionTimeAction,
  updatePreInterventionDateAction,
  updateSecondaryWorkerIdsAction,
  updateWorkerIdAction,
  updateBuildingSurfaceAction,
  updateGroundSurfaceAction,
  receiveFormAction,
} from '../actions/form';

const initialState = {
  interventionDate: undefined,
  interventionTime: undefined,
  preInterventionDate: undefined,
  visitDuration: undefined,
  visitDurationUnit: undefined,
  primaryWorkerId: undefined,
  secondaryWorkerIds: [],
  buildingSurface: undefined,
  groundSurface: undefined,
  isFetching: false,
  errors: [],
};

const ERRORS = 'errors';

export const formReducer = createReducer(initialState, {
  [updateInterventionDateAction](state, action) {
    return {
      ...state,
      interventionDate: action.payload,
    };
  },
  [updateInterventionTimeAction](state, action) {
    return {
      ...state,
      interventionTime: action.payload,
    };
  },
  [updatePreInterventionDateAction](state, action) {
    return {
      ...state,
      preInterventionDate: action.payload,
    };
  },
  [updateDurationAction](state, action) {
    return {
      ...state,
      visitDuration: action.payload,
    };
  },
  [updateDurationUnitAction](state, action) {
    return {
      ...state,
      visitDurationUnit: action.payload,
    };
  },
  [updateWorkerIdAction](state, action) {
    return {
      ...state,
      primaryWorkerId: action.payload,
    };
  },
  [updateSecondaryWorkerIdsAction](state, action) {
    return {
      ...state,
      secondaryWorkerIds: action.payload,
    };
  },
  [updateBuildingSurfaceAction](state, action) {
    return {
      ...state,
      buildingSurface: action.payload,
    };
  },
  [updateGroundSurfaceAction](state, action) {
    return {
      ...state,
      groundSurface: action.payload,
    };
  },
  [receiveFormAction](state, action) {
    return {
      ...action.payload,
      errors: [],
    };
  },
  [ERRORS](state, action) {
    return {
      ...state,
      errors: action.payload,
    };
  },
});

export default formReducer;

export const getErrors = state => state.form.errors;
export const getInterventionDate = state => state.form.interventionDate;
export const getInterventionTime = state => state.form.interventionTime;
export const getPreInterventionDate = state => state.form.preInterventionDate;
export const getVisitDuration = state => state.form.visitDuration;
export const getVisitDurationUnit = state => state.form.visitDurationUnit;
export const getPrimaryWorkerId = state => state.form.primaryWorkerId;
export const getSecondaryWorkerIds = state => state.form.secondaryWorkerIds;
export const getBuildingSurface = state => state.form.buildingSurface;
export const getGroundSurface = state => state.form.groundSurface;



// WEBPACK FOOTER //
// ./src/modules/saas/aast/case-contract/validation/reducers/form.js